
import React from 'react'

const RestrictionTree = ({ tree }: any) => {

  // tree example:
  // 1.
  //   1.1
  //     1.1.1
  //       1.1.1.1

  const renderTree = (index: number = 0) => {

    return (
      <div>
        {tree.map((item: string, index: number) => {

          const isLast = index === tree.length - 1

          return (
            <div key={index} style={{ marginLeft: `${index * 10}px` }}>
              <div
                className={`restriction-tree-item ${isLast ? 'last' : ''}`}
              >
                {item}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  return renderTree(0)

}

export default RestrictionTree
